<template>
  <div class="quiz-option-item">
    <div
      v-if="option.order && showOrder"
      class="quiz-option-index"
    >
      {{ option.order }}
    </div>
    <div class="flex gap-4">
      <div class="quiz-option-title">
        {{ option && option.title }}
        <div
          v-if="option.image"
          class="quiz-option-image-wrapper"
        >
          <div
            class="quiz-option-image-placeholder"
          >
            <img
              :src="option.image"
              class="quiz-option-image"
            >
          </div>
          <span class="quiz-option-check" />
          <span class="quiz-option-status" />
        </div>
      </div>
      <div class="quiz-option-title">
        {{ option && option.pairTitle }}
        <div
          v-if="option.pairImageCropped"
          class="quiz-option-image-wrapper"
        >
          <div
            class="quiz-option-image-placeholder"
          >
            <img
              :src="option.pairImageCropped"
              class="quiz-option-image"
            >
          </div>
          <span class="quiz-option-check" />
          <span class="quiz-option-status" />
        </div>
      </div>
    </div>
    <div class="quiz-option-status" v-if="showCheckMarkIcon">
      <aha-icon
        class="checkmark"
        :name="getStatus(option)"
        width="16"
        height="16"
        viewBox="0 0 18 18"
      ></aha-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    status: {
      type: String,
      default: '',
    },
    showCheckMarkIcon: {
      type: Boolean,
      default: true,
    },
    showOrder: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getStatus(option) {
      return option.correct ? 'correct' : 'incorrect'
    },
  },
}
</script>

<style lang="scss">
.quiz-option-item {
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid var(--secondary-20, #D3D7E1);
  padding: 12px;
  display: flex;
  align-items: center;

  &.border-none {
    border-color: transparent !important;
  }

  &.border-secondary:not(.checked) {
    border-color: var(--secondary-15, #EFF1F7);
  }

  &.correct {
    @apply border-green-50;
    border-width: 1px;
    border-style: solid;
    .quiz-option-status > .checkmark {
      @apply text-green-50;
      visibility: visible;
    }
  }

  &.incorrect {
      @apply border-red-100 ;
      border-width: 1px;
      border-style: solid;
    .quiz-option-status > .checkmark {
      @apply text-red-100;
      visibility: visible;
    }
  }
  &.no-right-or-wrong{
    .quiz-option-status > .checkmark {
      visibility: hidden;
    }
  }
}

.quiz-option-index {
  width: 20px;
  height:20px;
  color: #545454;
  font-weight: 700;
  display: grid;
  place-items: center;
  background: #F0F4FA;
  border-radius:50%;
  margin-right: 8px;
}

.quiz-option-check {
  display: flex;
  align-items: center;
  width: 20px;
  flex-basis: 20px;
  flex-shrink: 0;
}

.quiz-option-image{
  width: 100px;
}
.quiz-option-title {
  flex-grow: 1;
  word-break: break-word;

  &:first-child {
    padding-left: 0;
  }
}

.quiz-option-status {
  width: 20px;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;

}
</style>
